import React__default from 'react';
import './switch.css.js';

const VARIANT_COLOR = {
    primary: "#3b82f6",
    secondary: "#6b7280",
    success: "#10b981",
    error: "#ef4444",
};
function Switch({ checked, onChange, label, variant = "primary", icon, disabled = false, }) {
    const bgColor = checked ? VARIANT_COLOR[variant] : "#e5e7eb";
    return (React__default.createElement("label", { className: "switch-wrapper", style: { cursor: disabled ? "not-allowed" : "pointer" } },
        React__default.createElement("input", { type: "checkbox", checked: checked, onChange: (e) => onChange(e.target.checked), disabled: disabled }),
        React__default.createElement("div", { className: `switch ${disabled ? "disabled" : ""}`, style: { backgroundColor: bgColor } },
            React__default.createElement("div", { className: "switch-handle" }, icon && checked ? icon : null)),
        label && React__default.createElement("span", { className: "switch-label" }, label)));
}

export { Switch };
//# sourceMappingURL=Switch.js.map
